setTimeout(()=>{
 const elm = document.querySelector('form[action="/cart/add"] input[name="id"]');
  if(elm){
    const observer = new MutationObserver(()=>{
      console.log(123);
      setTimeout(()=>{
    BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, false, false);
      }, 1000)
    })
    observer.observe(elm, {attributes: true})
  }
}, 300)